import { Injectable } from "@angular/core";
import { Http, Response, Headers, RequestOptions } from "@angular/http";
import { CookieService } from "ngx-cookie-service";
import { Observable } from "rxjs/Observable";
import { AppCommonService } from "../appcommon.service";
import { AuthService } from "../auth.service";
import { GlobalService } from "../global.service";
import { Router } from "@angular/router";
import { ApiEndPoints } from "../api.endpoints";
import { forEach } from "@angular/router/src/utils/collection";
import { LiveCard, CostCentre, CardDrawing, CardDetail, PendingStopCard, ReduntantCard, CardDrawingEndPoint, PurchaseOption, CardAddress, CreateCardModel, StopCardModel, CardHistory, CardHistoryModel, CardRequestModel, CardRequest, LiveCardModel, PendingStopCardModel, ReduntantCardModel, CostCentreModel, CardDetailModel, CardDrawingModel, DrawingPointModel, PurchaseOptionModel, CardAddressModel, CreateCardPassModel, StopCardPassModel, LiveStopCardModel } from "./managecards";
import { AcceptedResponse } from "../cardtransaction/cardtransaction";

@Injectable()
export class ManagedCardService extends GlobalService {
    constructor(
        private http: Http,
        private cookieService: CookieService,
        private appCommonService: AppCommonService,
        private authService: AuthService,
        private router: Router
    ) {
        super(http, router);
        this.authServiceRef = this.authService;
    }

    //getLiveCards(): Observable<LiveCard[]> {
    //  let headers = this.authService.GetAuthHeader();
    //  let options = new RequestOptions({ headers: headers });
    //  const url = ApiEndPoints.LiveCardsEndPoint;
    //  return this.http.get(url, options)
    //    .map(this.extractData)
    //    // .do(data => console.log('getProduct: ' + JSON.stringify(data)))
    //    .catch(this.handleError);
    //}

    getLiveCards(model: LiveCardModel): Observable<LiveCard[]> {
        let body = JSON.stringify(model);
        let callURL = ApiEndPoints.BaseURL + ApiEndPoints.GetLiveCards;
        //let headers: Headers = new Headers({
        //  'Content-Type': 'application/json; charset=utf-8'
        //});
        let options = new RequestOptions({ headers: this.authService.GetHeader() });
        return this.http.post(callURL, body, options)
            .map((response: Response) => <any>response.json())
            .catch(this.handleError);
    }

    getStopCards(model: LiveStopCardModel): Observable<LiveCard[]> {
        let body = JSON.stringify(model);
        let callURL = ApiEndPoints.BaseURL + ApiEndPoints.GetStopCards;
        //let headers: Headers = new Headers({
        //  'Content-Type': 'application/json; charset=utf-8'
        //});
        let options = new RequestOptions({ headers: this.authService.GetHeader() });
        return this.http.post(callURL, body, options)
            .map((response: Response) => <any>response.json())
            .catch(this.handleError);
    }

    getCostCentreByCardId(id: string): Observable<CostCentre[]> {
        if (ApiEndPoints.UseDirectEndPoint) {
            let headers = this.authService.GetAuthHeader();
            let options = new RequestOptions({ headers: headers });
            const url = ApiEndPoints.CostCentresByCardIdEndPoint.replace('{cardId}', id);
            return this.http.get(url, options)
                .map(this.extractData)
                .catch(this.handleError);
        } else {
            let token = this.authService.getToken();
            let model = new CostCentreModel();
            // model.EndPointURL = ApiEndPoints.CostCentresByCardIdEndPoint;
            model.CardId = id;
            model.Token = token.access_token;
            let body = JSON.stringify(model);
            //let headers: Headers = new Headers({
            //  'Content-Type': 'application/json; charset=utf-8'
            //});
            let options = new RequestOptions({ headers: this.authService.GetHeader() });
            let callURL = ApiEndPoints.BaseURL + ApiEndPoints.CostCentresByCardIdEndPointServer;
            return this.http.post(callURL, body, options)
                .map((response: Response) => <any>response.json())
                .catch(this.handleError);
        }
    }

    createCostCentreNew(costCentre: CostCentre, id: string, userId: string, accountNumbers: string[]): Observable<CostCentre> {
        if (ApiEndPoints.UseDirectEndPoint) {
            let headers = this.authService.GetAuthHeader();
            let options = new RequestOptions({ headers: headers });
            const url = ApiEndPoints.CostCentresByCardIdEndPoint.replace('{cardId}', id);
            return this.http.post(url, costCentre, options)
                .catch(this.handleError);
        } else {
            let token = this.authService.getToken();
            let model = new CostCentreModel();
            // model.EndPointURL = ApiEndPoints.CostCentresByCardIdEndPoint;
            model.Token = token.access_token;
            model.CostCentre = costCentre;
            model.CardId = id;
            model.UserId = userId;
            model.AccountNumbers = accountNumbers;

            let body = JSON.stringify(model);
            //let headers: Headers = new Headers({
            //  'Content-Type': 'application/json; charset=utf-8'
            //});
            let options = new RequestOptions({ headers: this.authService.GetHeader() });
            let callURL = ApiEndPoints.BaseURL + ApiEndPoints.CostCentresByCardIdEndPointSaveServer;
            return this.http.post(callURL, body, options)
                .map((response: Response) => <any>response.json())
                .catch(this.handleError);
        }
    }

    createCostCentre(costCentre: CostCentre, id: string): Observable<CostCentre> {
        if (ApiEndPoints.UseDirectEndPoint) {
            let headers = this.authService.GetAuthHeader();
            let options = new RequestOptions({ headers: headers });
            const url = ApiEndPoints.CostCentresByCardIdEndPoint.replace('{cardId}', id);
            return this.http.post(url, costCentre, options)
                .catch(this.handleError);
        } else {
            let token = this.authService.getToken();
            let model = new CostCentreModel();
            //model.EndPointURL = ApiEndPoints.CostCentresByCardIdEndPoint;
            model.Token = token.access_token;
            model.CostCentre = costCentre;
            model.CardId = id;
            let body = JSON.stringify(model);
            //let headers: Headers = new Headers({
            //  'Content-Type': 'application/json; charset=utf-8'
            //});
            let options = new RequestOptions({ headers: this.authService.GetHeader() });
            let callURL = ApiEndPoints.BaseURL + ApiEndPoints.CostCentresByCardIdEndPointSaveServer;
            return this.http.post(callURL, body, options)
                .map((response: Response) => <any>response.json())
                .catch(this.handleError);
        }
    }


    deleteCostCentreNew(costCentre: CostCentre, id: string, userId: string, accountNumbers: string[]): Observable<CostCentre> {
        if (ApiEndPoints.UseDirectEndPoint) {
            let headers = this.authService.GetAuthHeader();
            let options = new RequestOptions({ headers: headers });
            const url = ApiEndPoints.CostCentresByCardIdEndPoint.replace('{cardId}', id) + "/" + costCentre.id;
            return this.http.delete(url, options)
                .catch(this.handleError);
        } else {
            let token = this.authService.getToken();
            let model = new CostCentreModel();
            // model.EndPointURL = ApiEndPoints.CostCentresByCardIdEndPoint.replace('{cardId}', id) + "/" + costCentre.id;
            model.Token = token.access_token;
            model.CardId = id;
            model.UserId = userId;
            model.CostCentreId = costCentre.id;
            model.AccountNumbers = accountNumbers;
            debugger;
            // model.CostCenterUrl = ApiEndPoints.CostCentresByCardIdEndPoint;
            let body = JSON.stringify(model);
            //let headers: Headers = new Headers({
            //  'Content-Type': 'application/json; charset=utf-8'
            //});
            let options = new RequestOptions({ headers: this.authService.GetHeader() });
            let callURL = ApiEndPoints.BaseURL + ApiEndPoints.CostCentresByCardIdEndPointDeleteServer;
            return this.http.post(callURL, body, options)
                .map((response: Response) => <any>response.json())
                .catch(this.handleError);
        }
    }

    deleteCostCentre(costCentre: CostCentre, id: string): Observable<CostCentre> {
        if (ApiEndPoints.UseDirectEndPoint) {
            let headers = this.authService.GetAuthHeader();
            let options = new RequestOptions({ headers: headers });
            const url = ApiEndPoints.CostCentresByCardIdEndPoint.replace('{cardId}', id) + "/" + costCentre.id;
            return this.http.delete(url, options)
                .catch(this.handleError);
        } else {
            let token = this.authService.getToken();
            let model = new CostCentreModel();
            
            model.EndPointURL = ApiEndPoints.CostCentresByCardIdEndPoint.replace('{cardId}', id) + "/" + costCentre.id;
            model.Token = token.access_token;
            model.CardId = id;
            model.CostCentreId = costCentre.id;
            let body = JSON.stringify(model);
            //let headers: Headers = new Headers({
            //  'Content-Type': 'application/json; charset=utf-8'
            //});
            let options = new RequestOptions({ headers: this.authService.GetHeader() });
            let callURL = ApiEndPoints.BaseURL + ApiEndPoints.CostCentresByCardIdEndPointDeleteServer;
            return this.http.post(callURL, body, options)
                .map((response: Response) => <any>response.json())
                .catch(this.handleError);
        }
    }

    getDrawingsByCardId(id: string): Observable<CardDrawing[]> {
        if (ApiEndPoints.UseDirectEndPoint) {
            let headers = this.authService.GetAuthHeader();
            let options = new RequestOptions({ headers: headers });
            const url = ApiEndPoints.DrawingsByCardIdEndPoint.replace('{cardId}', id);
            //debugger;
            return this.http.get(url, options)
                .map(this.extractData)
                .catch(this.handleError);
        }
        else {
            let token = this.authService.getToken();
            let model = new CardDrawingModel();
            //model.EndPointURL = ApiEndPoints.DrawingsByCardIdEndPoint;
            model.CardId = id;
            model.Token = token.access_token;
            let body = JSON.stringify(model);
            //let headers: Headers = new Headers({
            //  'Content-Type': 'application/json; charset=utf-8'
            //});
            let options = new RequestOptions({ headers: this.authService.GetHeader() });
            let callURL = ApiEndPoints.BaseURL + ApiEndPoints.DrawingsByCardIdEndPointServer;
            return this.http.post(callURL, body, options)
                .map((response: Response) => <any>response.json())
                .catch(this.handleError);
        }
    }

    getCardById(id: string): Observable<CardDetail> {
        if (ApiEndPoints.UseDirectEndPoint) {
            let headers = this.authService.GetAuthHeader();
            let options = new RequestOptions({ headers: headers });
            const url = ApiEndPoints.CardByIdEndPoint.replace('{cardId}', id);
            return this.http.get(url, options)
                .map(this.extractData)
                .catch(this.handleError);
        } else {
            let token = this.authService.getToken();
            let model = new CardDetailModel();
            model.EndPointURL = ApiEndPoints.CardByIdEndPoint;
            model.CardId = id;
            model.Token = token.access_token;
            let body = JSON.stringify(model);
            //let headers: Headers = new Headers({
            //  'Content-Type': 'application/json; charset=utf-8'
            //});
            let options = new RequestOptions({ headers: this.authService.GetHeader() });
            let callURL = ApiEndPoints.BaseURL + ApiEndPoints.CardByIdEndPointServer;
            return this.http.post(callURL, body, options)
                .map((response: Response) => <any>response.json())
                .catch(this.handleError);
        }
    }

    //getPendingStopCards(): Observable<PendingStopCard[]> {
    //  let headers = this.authService.GetAuthHeader();
    //  let options = new RequestOptions({ headers: headers });
    //  const url = ApiEndPoints.PendingStopCardsEndPoint;
    //  return this.http.get(url, options)
    //    .map(this.extractData)
    //    // .do(data => console.log('getProduct: ' + JSON.stringify(data)))
    //    .catch(this.handleError);
    //}

    getPendingStopCards(model: PendingStopCardModel): Observable<PendingStopCard[]> {
        let body = JSON.stringify(model);
        let callURL = ApiEndPoints.BaseURL + ApiEndPoints.GetPendingStopCards;
        //let headers: Headers = new Headers({
        //  'Content-Type': 'application/json; charset=utf-8'
        //});
        let options = new RequestOptions({ headers: this.authService.GetHeader() });
        return this.http.post(callURL, body, options)
            .map((response: Response) => <any>response.json())
            .catch(this.handleError);
    }

    //getReduntantCards(): Observable<ReduntantCard[]> {
    //  let headers = this.authService.GetAuthHeader();
    //  let options = new RequestOptions({ headers: headers });
    //  const url = ApiEndPoints.ReduntantCardsEndPoint;
    //  return this.http.get(url, options)
    //    .map(this.extractData)
    //    // .do(data => console.log('getProduct: ' + JSON.stringify(data)))
    //    .catch(this.handleError);
    //}

    getReduntantCards(model: ReduntantCardModel): Observable<ReduntantCard[]> {
        let body = JSON.stringify(model);
        let callURL = ApiEndPoints.BaseURL + ApiEndPoints.GetReduntantCards;
        //let headers: Headers = new Headers({
        //  'Content-Type': 'application/json; charset=utf-8'
        //});
        let options = new RequestOptions({ headers: this.authService.GetHeader() });
        return this.http.post(callURL, body, options)
            .map((response: Response) => <any>response.json())
            .catch(this.handleError);
    }

    getDrawingPointsByAccountId(id: string): Observable<CardDrawingEndPoint[]> {

        if (ApiEndPoints.UseDirectEndPoint) {
            let headers = this.authService.GetAuthHeader();
            let options = new RequestOptions({ headers: headers });
            const url = ApiEndPoints.CreateCardDrawingPointEndPoint.replace('{accountId}', id);
            return this.http.get(url, options)
                .map(this.extractData)
                .catch(this.handleError);
        } else {
            let token = this.authService.getToken();
            let model = new DrawingPointModel();
            //model.EndPointURL = ApiEndPoints.CreateCardDrawingPointEndPoint;
            model.AccountId = id;
            model.Token = token.access_token;
            let body = JSON.stringify(model);
            //let headers: Headers = new Headers({
            //  'Content-Type': 'application/json; charset=utf-8'
            //});
            let options = new RequestOptions({ headers: this.authService.GetHeader() });
            let callURL = ApiEndPoints.BaseURL + ApiEndPoints.CreateCardDrawingPointEndPointServer;
            return this.http.post(callURL, body, options)
                .map((response: Response) => <any>response.json())
                .catch(this.handleError);
        }

    }

    getPurchaseOptionByLedgerNumber(id: string): Observable<PurchaseOption[]> {
        //debugger;
        if (ApiEndPoints.UseDirectEndPoint) {
            let headers = this.authService.GetAuthHeader();
            let options = new RequestOptions({ headers: headers });
            const url = id;
            //const url = ApiEndPoints.PurchaseOptionsEndPoint + id;
            return this.http.get(url, options)
                .map(this.extractData)
                .catch(this.handleError);
        } else {
            let token = this.authService.getToken();
            let model = new PurchaseOptionModel();
            //model.EndPointURL = ApiEndPoints.PurchaseOptionsEndPoint + id;
            model.EndPointURL = id;
            model.Token = token.access_token;
            let body = JSON.stringify(model);
            //let headers: Headers = new Headers({
            //  'Content-Type': 'application/json; charset=utf-8'
            //});
            let options = new RequestOptions({ headers: this.authService.GetHeader() });
            let callURL = ApiEndPoints.BaseURL + ApiEndPoints.PurchaseOptionsEndPointServer;
            return this.http.post(callURL, body, options)
                .map((response: Response) => <any>response.json())
                .catch(this.handleError);
        }

    }

    getCompanyCardAddressListByCompanyId(id: string): Observable<CardAddress[]> {
        // debugger
        if (ApiEndPoints.UseDirectEndPoint) {
            let headers = this.authService.GetAuthHeader();
            let options = new RequestOptions({ headers: headers });
            const url = ApiEndPoints.CompanyCardAddressEndPoint.replace('{companyId}', id);
            return this.http.get(url, options)
                .map(this.extractData)
                .catch(this.handleError);
        }
        else {
            let token = this.authService.getToken();
            let model = new CardAddressModel();
            //model.EndPointURL = ApiEndPoints.CompanyCardAddressEndPoint;
            model.CompanyId = id;
            model.Token = token.access_token;
            let body = JSON.stringify(model);
            //let headers: Headers = new Headers({
            //  'Content-Type': 'application/json; charset=utf-8'
            //});
            let options = new RequestOptions({ headers: this.authService.GetHeader() });
            // debugger
            let callURL = ApiEndPoints.BaseURL + ApiEndPoints.CompanyCardAddressEndPointServer;
            return this.http.post(callURL, body, options)
                .map((response: Response) => <any>response.json())
                .catch(this.handleError);
        }
    }

    createCardAddress(cardAddress: CardAddress, id: string): Observable<CardAddress> {
        if (ApiEndPoints.UseDirectEndPoint) {
            let headers = this.authService.GetAuthHeader();
            let options = new RequestOptions({ headers: headers });
            const url = ApiEndPoints.CompanyCardAddressEndPoint.replace('{companyId}', id);
            return this.http.post(url, cardAddress, options)
                .catch(this.handleError);
        } else {
            let token = this.authService.getToken();
            let model = new CardAddressModel();
            //model.EndPointURL = ApiEndPoints.CompanyCardAddressEndPoint;
            model.Token = token.access_token;
            model.CardAddress = cardAddress;
            model.CompanyId = id;
            let body = JSON.stringify(model);
            //let headers: Headers = new Headers({
            //  'Content-Type': 'application/json; charset=utf-8'
            //});
            let options = new RequestOptions({ headers: this.authService.GetHeader() });
            let callURL = ApiEndPoints.BaseURL + ApiEndPoints.CompanyCardAddressEndPointSaveServer;
            return this.http.post(callURL, body, options)
                .map((response: Response) => <any>response.json())
                .catch(this.handleError);
        }
    }

    deleteCardAddress(cardAddress: CardAddress, id: string): Observable<CardAddress> {
        if (ApiEndPoints.UseDirectEndPoint) {
            let headers = this.authService.GetAuthHeader();
            let options = new RequestOptions({ headers: headers });
            const url = ApiEndPoints.CompanyCardAddressEndPoint.replace('{companyId}', id) + "/" + cardAddress.id;
            return this.http.delete(url, options)
                .catch(this.handleError);
        }
        else {
            let token = this.authService.getToken();
            let model = new CardAddressModel();
            //model.EndPointURL = ApiEndPoints.CompanyCardAddressEndPoint.replace('{companyId}', id) + "/" + cardAddress.id;
            model.Token = token.access_token;
            model.CompanyId = id;
            model.cardAddressId = cardAddress.id.toString();
            let body = JSON.stringify(model);
            //let headers: Headers = new Headers({
            //  'Content-Type': 'application/json; charset=utf-8'
            //});
            let options = new RequestOptions({ headers: this.authService.GetHeader() });
            let callURL = ApiEndPoints.BaseURL + ApiEndPoints.CompanyCardAddressEndPointDeleteServer;
            return this.http.post(callURL, body, options)
                .map((response: Response) => <any>response.json())
                .catch(this.handleError);
        }
    }

    createCards(createCardModel: CreateCardModel): Observable<CreateCardModel> {
        if (ApiEndPoints.UseDirectEndPoint) {
            let headers = this.authService.GetAuthHeader();
            let options = new RequestOptions({ headers: headers });
            const url = ApiEndPoints.CreateCardsEndPoint;
            return this.http.post(url, createCardModel, options)
                .catch(this.handleError);
        } else {
            let token = this.authService.getToken();
            let model = new CreateCardPassModel();
            model.EndPointURL = ApiEndPoints.CreateCardsEndPoint;
            model.Token = token.access_token;
            model.CreateCards = createCardModel;
            let body = JSON.stringify(model);
            //let headers: Headers = new Headers({
            //  'Content-Type': 'application/json; charset=utf-8'
            //});
            let options = new RequestOptions({ headers: this.authService.GetHeader() });
            let callURL = ApiEndPoints.BaseURL + ApiEndPoints.CreateCardsEndPointSaveServer;
            return this.http.post(callURL, body, options)
                .map((response: Response) => <any>response.json())
                .catch(this.handleError);
        }
    }

    stopCards(stopCardModel: StopCardModel): Observable<StopCardModel> {
        if (ApiEndPoints.UseDirectEndPoint) {
            let headers = this.authService.GetAuthHeader();
            let options = new RequestOptions({ headers: headers });
            const url = ApiEndPoints.StopCardsEndPoint;
            return this.http.post(url, stopCardModel, options)
                .catch(this.handleError);
        }
        else {
            let token = this.authService.getToken();
            let model = new StopCardPassModel();
            //model.EndPointURL = ApiEndPoints.StopCardsEndPoint;
            model.Token = token.access_token;
            model.StopCards = stopCardModel;
            let body = JSON.stringify(model);
            //let headers: Headers = new Headers({
            //  'Content-Type': 'application/json; charset=utf-8'
            //});
            let options = new RequestOptions({ headers: this.authService.GetHeader() });
            let callURL = ApiEndPoints.BaseURL + ApiEndPoints.StopCardsEndPointSaveServer;
            return this.http.post(callURL, body, options)
                .map((response: Response) => <any>response.json())
                .catch(this.handleError);
        }
    }


    ClearStopCardsMemory(userId: string, type: string): Observable<null> {
        let callURL = ApiEndPoints.BaseURL + ApiEndPoints.ClearMemoryLeakCommon;
        callURL = callURL.replace("{userId}", userId).replace("{type}", type);
        //let headers: Headers = new Headers({
        //  'Content-Type': 'application/json; charset=utf-8'
        //});
        let options = new RequestOptions({ headers: this.authService.GetHeader() });
        return this.http.get(callURL, options)
            .map((response: Response) => <any>response.json())
            .catch(this.handleError);
    }


    getCardHistories(model: CardHistoryModel): Observable<CardHistory[]> {
        let body = JSON.stringify(model);
        let callURL = ApiEndPoints.BaseURL + ApiEndPoints.GetCardHistories;
        //let headers: Headers = new Headers({
        //  'Content-Type': 'application/json; charset=utf-8'
        //});
        //let options = new RequestOptions({ headers: headers });
        let options = new RequestOptions({ headers: this.authService.GetHeader() });
        return this.http.post(callURL, body, options)
            .map((response: Response) => <any>response.json())
            .catch(this.handleError);
    }

    getCardRequests(model: CardRequestModel): Observable<CardRequest[]> {
        let body = JSON.stringify(model);
        let callURL = ApiEndPoints.BaseURL + ApiEndPoints.GetCardRequests;
        //let headers: Headers = new Headers({
        //  'Content-Type': 'application/json; charset=utf-8'
        //});
        let options = new RequestOptions({ headers: this.authService.GetHeader() });
        return this.http.post(callURL, body, options)
            .map((response: Response) => <any>response.json())
            .catch(this.handleError);
    }

    checkLiveCardStatus(location: any): Observable<AcceptedResponse> {
        let callURL = location;
        //let headers: Headers = new Headers({
        //  'Content-Type': 'application/json; charset=utf-8'
        //});
        callURL = callURL + "?key=" + this.authService.getToken().access_token;
        let options = new RequestOptions({ headers: this.authService.GetHeader() });
        return this.http.get(callURL, options)
            .map((response: Response) => <any>response.json())
            .catch(this.handleError);
    }


    getLiveCardsNew(model: LiveCardModel): Observable<AcceptedResponse> {
        let body = JSON.stringify(model);
        let callURL = ApiEndPoints.BaseURL + ApiEndPoints.GetLiveCardsNew;
        //let headers: Headers = new Headers({
        //  'Content-Type': 'application/json; charset=utf-8'
        //});
        let options = new RequestOptions({ headers: this.authService.GetHeader() });
        return this.http.post(callURL, body, options)
            .map((response: Response) => <any>response.json())
            .catch(this.handleError);
    }

    prePareLiveCardDocument(refNumber: string, type: string, sort: string): Observable<AcceptedResponse> {
        let callURL = ApiEndPoints.BaseURL + ApiEndPoints.PrePareLiveCardsEndPoint;
        callURL = callURL.replace("{id}", refNumber).replace("{type}", type).replace("{sort}", sort);
        //let headers: Headers = new Headers({
        //  'Content-Type': 'application/json; charset=utf-8'
        //});
        let options = new RequestOptions({ headers: this.authService.GetHeader() });
        return this.http.get(callURL, options)
            .map((response: Response) => <any>response.json())
            .catch(this.handleError);
    }


}



// WEBPACK FOOTER //
// ./src/app/managecards/managecards.service.ts